// ==================================================================================== SECTION 1
// ========================================== SEARCH
let coSearchButton = document.querySelector('.co-blog-search-button');
coSearchButton.addEventListener('click', function(e) {
  e.preventDefault();
  setTimeout(function() {
      document.querySelector('.header__icon--search').click();
  }, 100);
});
// ========================================== FILTER
// POPUP
let coShopSection3OpenButton = document.querySelector('.co-blog-filter-button');
let coShopSection3CloseButton = document.querySelector('#co-blog-section-1-popup-close-button-id');
let coShopSection3 = document.querySelector('#co-blog-section-1-popup-id');
let coShopSection3Body = document.querySelector('body');
let coShopSection3Animate = document.querySelector('.co-blog-section-1-popup-animate');
coShopSection3OpenButton.addEventListener('click', function(e) {
  e.preventDefault();
  if (!coShopSection3.classList.contains('co-blog-section-1-popup-active')) {
    coShopSection3.classList.add('co-blog-section-1-popup-active');
  }
  if (!coShopSection3Body.classList.contains('co-overflow-hidden')) {
    coShopSection3Body.classList.add('co-overflow-hidden');
  }
  if (!coShopSection3OpenButton.classList.contains('co-active')) {
    setTimeout(function() {
      coShopSection3OpenButton.classList.add('co-active');
    }, 50);
  }
  if (!coShopSection3Animate.classList.contains('co-blog-section-1-popup-animate-active')) {
    setTimeout(function() {
      coShopSection3Animate.classList.add('co-blog-section-1-popup-animate-active');
    }, 50);
  }    
});
coShopSection3CloseButton.addEventListener('click', function(e) {
  e.preventDefault();
  if (coShopSection3.classList.contains('co-blog-section-1-popup-active')) {
    coShopSection3.classList.remove('co-blog-section-1-popup-active');
  }
  if (coShopSection3Body.classList.contains('co-overflow-hidden')) {
    coShopSection3Body.classList.remove('co-overflow-hidden');
  }
  if (coShopSection3OpenButton.classList.contains('co-active')) {
    coShopSection3OpenButton.classList.remove('co-active');
  }
  if (coShopSection3Animate.classList.contains('co-blog-section-1-popup-animate-active')) {
    setTimeout(function() {
      coShopSection3Animate.classList.remove('co-blog-section-1-popup-animate-active');
    }, 50);
  }    
});
// ========================================== GSAP
ScrollTrigger.create({
  // markers: true,
  trigger: 'body',
  start: "top top",
  end: "bottom bottom",
  pin: ".co-blog-section-1-popup-wrapper",
  pinSpacing: false,
}); 
// ==================================================================================== SECTION 1
// ENTRY
gsap.to('.co-blog-section-1-frame', { 
  opacity: 1, 
  duration: 1 
});
